module.exports = __webpack_public_path__ + "static/media/logo-invoice@3x.468aad10.png";